import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import anime from 'animejs';

const notice = document.querySelector<HTMLElement>('[data-mobile-notice]');
const dismiss = notice?.querySelector<HTMLElement>('[data-dismiss]');

const cookieName = 'mobile_warning_dismissed';

export const dismissedOrNotApplicable = () => {
	const wasDismissed = document.cookie
		.split(';')
		.some((cookie) => cookie.trim().startsWith(`${cookieName}=`));
	const notApplicable = matchMedia && matchMedia('(min-width: 576px)').matches;
	return wasDismissed || notApplicable;
};

if (notice) {
	if (dismissedOrNotApplicable()) {
		notice.parentNode?.removeChild(notice);
	} else {
		document.documentElement.classList.add('has-mobile-notice');
		disableBodyScroll(notice);

		dismiss?.addEventListener('click', () => {
			enableBodyScroll(notice);
			document.cookie = `${cookieName}=true;path=/;max-age=${60 * 60 * 24}`;
			document.documentElement.classList.remove('has-mobile-notice');
			anime({
				targets: notice,
				translateY: ['0%', '100%'],
				duration: 300,
				easing: 'easeOutCubic',
			});
		});
	}
}
